import dsnAxios from './axios';
import { getAuthRedirectUrl } from './environment';

/**
 * Fetches the remaining lifetime of the user's IMS access token from Iron.
 *
 * Returns null when the endpoint is unavailable or the user's session
 * predates the imsExpiresAt JWT claim and the IMS token is opaque.
 * Callers should treat null as "expiry unknown" and let the user proceed,
 * rather than blocking them on missing data.
 */
export async function fetchImsTokenExpiry() {
  try {
    const { data } = await dsnAxios.get('ims-token/expiry');
    if (data?.status !== 'success') return null;
    return {
      expiresAt: data.expiresAt,
      secondsRemaining: data.secondsRemaining,
      isExpired: data.isExpired,
      // True when IMS issued a pathologically short TTL. Re-authentication
      // would NOT help — Adobe would just issue another short-lived token —
      // so callers should avoid prompting reauth in this case.
      pathological: !!data.pathological
    };
  } catch (error) {
    // 404 is the documented "no expiry recorded" response (older session).
    // Anything else (network, 5xx, …) we also treat as unknown rather than
    // false-blocking the user.
    return null;
  }
}

/**
 * Signs the user out of the DSN session and redirects to the IMS login.
 * Used by the Quick Setup re-authentication flow when the IMS token is
 * about to expire mid-run.
 */
export async function reauthenticate() {
  try {
    await dsnAxios.post('sign-out');
  } catch (error) {
    // If sign-out fails we still redirect to login; worst case the user
    // sees the IMS login screen with their existing session and gets a
    // fresh token via the OAuth round-trip.
  }
  window.location = getAuthRedirectUrl();
}
